/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button, Icon, MenuItem, TextField, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { Trim } from '../../../common/util';
import apiService from '../../../services.js/apiService';
import OverLoading from '../../../components/global/OverLoading';
import Editor from '../../../components/post/article/editor';
import Constants from '../../../common/constants';
import { IsEmpty } from '../../../common/checks';
import colours from '../../../styles/colours';

const MobileAppVersionAdd = (props) => {
  const [formData, setFormData] = useState({ description: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [plainText, setPlainText] = useState('');

  const mobileAppVersionId = props.match.params.id;
  const history = useHistory();
  const versionNamePattern = /^\d+(\.\d+){0,2}$/;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onChangePlainText = (data) => {
    setPlainText(data);
  };

  const fetchData = async () => {
    if (mobileAppVersionId) {
      try {
        const mobileAppVersion = await apiService.getMobileAppVersion(mobileAppVersionId);
        setFormData({ ...mobileAppVersion });
      } catch (err) {
        toast.error(err.message);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, [mobileAppVersionId]);

  const onSubmit = async (e) => {
    e.preventDefault();
    e.persist();

    const curError = {};
    const setToBlank = {};
    let isAllValid = true;
    for (const key in formData) {
      if (key === 'id') {
        continue;
      }

      if (Trim(formData[key]) === '' || IsEmpty(formData[key])) {
        curError[key] = `This field not allowed to be empty`;
        setToBlank[key] = '';
        isAllValid = false;
      } else {
        curError[key] = '';
      }
    }

    setErrors({ ...curError });

    if (!formData.versionName.match(versionNamePattern)) {
      isAllValid = false;
      curError.versionName = `Please use number only, Example: 1.2.0 or 1.3 or 1`;
      setErrors({ ...curError });
      return;
    }
    if (!isAllValid) {
      return;
    }

    if (mobileAppVersionId) {
      setLoading(true);
      try {
        const mobileAppVersion = await apiService.updateMobileAppVersion(mobileAppVersionId, formData);
        toast.success('Update mobile app version success');

        setFormData({ ...mobileAppVersion });
      } catch (err) {
        toast.error(err.message);
      }
      setLoading(false);
    } else {
      setLoading(true);
      try {
        const mobileAppVersion = await apiService.addMobileAppVersion(formData);
        toast.success('Create mobile app version success');
        history.replace(`/admin/mobileApp/mobileAppVersion/${mobileAppVersion.id}`);
      } catch (err) {
        toast.error(err.message);
      }
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="content-header d-flex align-items-center justify-content-start py-3">
        <Button onClick={() => { history.replace('/admin/mobileApp/mobileAppVersion'); }} size="large" className="ml-0">
          <Icon fontSize="large">arrow_back</Icon>
        </Button>

        <Typography variant="h4" style={{ fontWeight: 'bold' }}>{`${mobileAppVersionId ? 'Update' : 'Add'} Mobile App Version Info`}</Typography>
      </div>
      <form
        className="form position-relative px-4"
        onSubmit={(e) => onSubmit(e)}
        autoComplete="off"
      >
        {loading && <OverLoading />}
        <div className="row">
          <div className="col-lg-6 col-sm-12 form-section">

            <div className="form-group">
              <Typography variant="h6">Version Name *</Typography>
              <input
                type="text"
                className="form-control"
                name="versionName"
                id="Version Name"
                value={formData.versionName || ''}
                onChange={(e) => onChange(e)}
                required
              />
              <span style={{ color: colours.Red }}>{errors.versionName}</span>
            </div>

            <div className="form-group">
              <Typography variant="h6">Version Type *</Typography>
              <TextField
                id="versionType"
                name="versionType"
                variant="outlined"
                size="small"
                className="form-control"
                value={formData.versionType || ''}
                select
                onChange={(e) => onChange(e)}
                required
              >
                <MenuItem value={Constants.mobileAppVersionType.Optional}>{`${Constants.mobileAppVersionType.Optional} Update`}</MenuItem>
                <MenuItem value={Constants.mobileAppVersionType.Compulsory}>{`${Constants.mobileAppVersionType.Compulsory} Update`}</MenuItem>
              </TextField>
              <span style={{ color: colours.Red }}>{errors.versionType}</span>
            </div>

            <div className="form-group mt-4">
              <Typography variant="h6">Upload Status *</Typography>
              <TextField
                id="uploadStatus"
                name="uploadStatus"
                className="form-control"
                variant="outlined"
                size="small"
                value={formData.uploadStatus || ''}
                select
                onChange={(e) => onChange(e)}
                required
              >
                <MenuItem value={Constants.PageStatus.Live}>{Constants.PageStatus.Live}</MenuItem>
                <MenuItem value={Constants.PageStatus.Pending}>{Constants.PageStatus.Pending}</MenuItem>
              </TextField>
              <span style={{ color: colours.Red }}>{errors.uploadStatus}</span>
            </div>

            <div className="form-group mt-5">
              <Typography variant="h6">Description *</Typography>
              <Editor
                key={formData.id}
                onChangeDescription={(e) => { onChange({ target: { value: e, name: 'description' } }); }}
                onChangePlainText={onChangePlainText}
                description={formData.description || ''}
                handleUploadImage={() => {
                  toast.error('Not allowed to upload image on this section');
                }}
              />
              <span style={{ color: colours.Red }}>{errors.description}</span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4 col-sm-12" />
          <div className="col-lg-2 col-sm-12">
            <div className="form-group">
              <input
                type="submit"
                className="btn btn-primary block"
                value={mobileAppVersionId ? 'Update' : 'Save'}
                onMouseDown={(e) => { e.preventDefault(); }}
              />
            </div>
          </div>
        </div>
      </form>
    </div>

  );
};

MobileAppVersionAdd.propTypes = {
  match: PropTypes.shape({ params: PropTypes.shape({ id: PropTypes.string }) }),
};

MobileAppVersionAdd.defaultProps = {
  match: {},
};

export default connect(null)(MobileAppVersionAdd);
